import { Box, CardMedia, IconButton, Modal, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { ContextData } from '@/ai/types/context-data';
import { AddRounded, CloseRounded } from '@mui/icons-material';
import { useAndieMemory } from '@/providers/andie-memory-provider';
import { useState } from 'react';

import { DashboardRounded, WysiwygRounded } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
const CONTEXT_ICONS = {
    DashboardRounded: <DashboardRounded />,
    WysiwygRounded: <WysiwygRounded />,
};

const AndieContextData = ({
    contextData,
    action = null,
}: {
    contextData: ContextData[];
    action?: 'add' | 'remove' | null;
}) => {
    const { t } = useTranslation();
    const [preview, setPreview] = useState<string | null>(null);
    const { clearContextData, setContextData } = useAndieMemory();

    if (contextData.length === 0) return null;

    return (
        <>
            <Modal
                open={!!preview}
                onClose={() => setPreview(null)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <CardMedia
                    component="img"
                    src={preview || ''}
                    sx={{
                        maxHeight: '90%',
                        maxWidth: '90%',
                        width: 'auto',
                        height: 'auto',
                        backgroundColor: 'background.default',
                    }}
                />
            </Modal>
            <Tooltip title={t('andie.chat.context-data.tooltip')} placement="top">
                <Stack direction="row" flexWrap="wrap" gap={1} width="fit-content">
                    {contextData.map((context) => {
                        const isTemp = context.data.duration === 'temp';
                        const display = context.display;

                        return (
                            <Paper
                                key={context.data.key}
                                variant="outlined"
                                sx={{ userSelect: 'none', fontSize: 'small' }}
                            >
                                <Stack direction="row" alignItems="center" gap={0.5} p={0.5}>
                                    {display?.type === 'icon' && (
                                        <Stack>
                                            {CONTEXT_ICONS[display.value] &&
                                                React.cloneElement(CONTEXT_ICONS[display.value], {
                                                    fontSize: 'small',
                                                })}
                                        </Stack>
                                    )}
                                    {display?.type === 'emoji' && (
                                        <Stack fontSize="small">{display.value}</Stack>
                                    )}
                                    {display?.type === 'image' && (
                                        <Box
                                            component="img"
                                            src={display.value}
                                            alt={context.showName}
                                            sx={{
                                                width: '1rem',
                                                height: '1rem',
                                                borderRadius: 1,
                                                objectFit: 'cover',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => setPreview(display.value)}
                                        />
                                    )}
                                    <Typography variant="subtitle2">{context.showName}</Typography>
                                    {isTemp &&
                                        (action === 'remove' ? (
                                            <Tooltip title={t('andie.chat.context-data.remove-tooltip')}>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => clearContextData(context.data.key)}
                                                    sx={{ p: 0 }}
                                                >
                                                    <CloseRounded fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        ) : (
                                            action === 'add' && (
                                                <Tooltip title={t('andie.chat.context-data.add-tooltip')}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setContextData(context)}
                                                        sx={{ p: 0 }}
                                                    >
                                                        <AddRounded fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )
                                        ))}
                                </Stack>
                            </Paper>
                        );
                    })}
                </Stack>
            </Tooltip>
        </>
    );
};

export default AndieContextData;
